import styled from 'styled-components'

export const PlanInfoGroupSelectContainer = styled.div`
  width: 100%;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`
